import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "autocomplete",
  class: "autocomplete"
}
const _hoisted_2 = {
  key: 0,
  name: "country",
  ref: "country",
  class: "custom-select form-control"
}
const _hoisted_3 = ["value", "selected"]
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  class: "autocomplete-result-list",
  ref: "list"
}
const _hoisted_6 = {
  class: "kmt-storefinder__locationsearch__locationhandler",
  ref: "browserlocation"
}
const _hoisted_7 = { class: "kmt-storefinder__locationsearch__overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["kmt-storefinder__locationsearch", [_ctx.isPendingCSSClass, _ctx.isUsingBrowserLocationCSSClass, _ctx.hasBrowserLocationPermissionCSSClass, _ctx.isFilterEnabledCSSClass]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isEnableCountryDropdown)
        ? (_openBlock(), _createElementBlock("select", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.windowVar.storefinder.geoapifyCountryTranslations, (value, name) => {
              return (_openBlock(), _createElementBlock("option", {
                key: name,
                value: name,
                selected: _ctx.windowVar.storefinder.defaultCountry === name
              }, _toDisplayString(value), 9, _hoisted_3))
            }), 128))
          ], 512))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        class: "autocomplete-input",
        placeholder: _ctx.translationComposition.placeholderTranslation,
        ref: "input"
      }, null, 8, _hoisted_4),
      _createElementVNode("ul", _hoisted_5, null, 512)
    ]),
    (_ctx.isEnableLocationSearch)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", _hoisted_6, null, 512),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.translationComposition.browserLocationTranslation), 1)
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}